(function($) {
  $('.hamburger-container').click( function() {
    $('.hamburger').toggleClass('active');
    $('.menu-mainmenu-container').toggleClass('active');
    $('.banner').toggleClass('active');
  });

  $('.menu-item-has-children').click( function() {
    $(this).children('.sub-menu').toggleClass('active');
  });
})(jQuery);


var width = (window.innerWidth > 0) ? window.innerWidth : screen.width;

if (width > 1040) {
  var header = new Headhesive('.header');
}
